// extracted by mini-css-extract-plugin
export default {"shimmerWrapper":"Shimmer_shimmerWrapper__YPHdF","shimmer":"Shimmer_shimmer__9W75O"};